"use client";
import React from "react";
import CustomerDetails from "../../../global/view/customer-detailsForm";

export default function AmendScriptCustomerDetails() {
  return (
    <CustomerDetails
      actionButtonLabel="Rewrite Script"
      backTo="/customer/dispensary"
    />
  );
}
